<template>
  <div ref="counter" class="counter">0</div>
</template>

<script>
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {AnimatedCounterProps} from "./AnimatedCounterProps";

gsap.registerPlugin(ScrollTrigger);

export default {
  name: "AnimatedCounter",
  props: {
    ...AnimatedCounterProps
  },
  data() {
    return {
      initialValue: 0,
      duration: this.durationProp,
    }
  },
  mounted() {
    let counter = this.$refs.counter;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: counter,
        start: "top bottom",
        once: true,
      },
    });

    tl.to(this,
        {
          duration: this.duration,
          initialValue: this.counterValue,
          roundProps: "initialValue",
          ease: "none",
          onUpdate: () => {
            counter.innerText = this.initialValue;
          },
        },
        "+=0"
    );


  }
}
</script>

<style scoped>

</style>